// extracted by mini-css-extract-plugin
export default {"supportChat":"supportChat_supportChat__VMJ7M","icon":"supportChat_icon__svu6p"};